import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Typo, Icon, Form } from 'tmt-ui-kit';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { actions as availabilityActions } from '~/redux/reducers/availability';
import { actions as sessionActions } from '~/redux/reducers/session';
import { createDateArray } from '~/utils/helpers';
import { showTodayOrTomorrowAvailable } from '~/utils/trip';
import withTrip from './withTrip';

moment.tz.setDefault('Asia/Bangkok');

const DatePickerContainer = styled.div`
  margin-bottom: 8px;
`;

const AvailableTodayOrTomorrowContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const InstantIcon = styled(Icon)`
  color: ${props => props.theme.orangeLighter};
  margin-right: 4px;
`;

const enhance = compose(
  connect(state => ({
    selectedMultiTier: state.trip.selectedMultiTier,
  })),
  connect(
    state => ({
      availability: state.availability,
      isLoadingSessionData: state.session.isLoadingSessionData,
      isSessionDataLoaded: state.session.isSessionDataLoaded,
      sessionData: state.session.data,
    }),
    (dispatch, props) => ({
      onChangeMonthYearCallback: (monthYear) => {
        const { trip } = props;
        let { selectedMultiTier } = props;
        if (!selectedMultiTier && trip.product_type === 'ticket') {
          selectedMultiTier = trip.multi_tier_prices
            .map((tier, idx) => ({
              ...tier,
              active: idx === 0
            }));
        }
        dispatch(
          availabilityActions.getTripAvailabilityV2(
            monthYear,
            trip._id,
            trip.product_type === 'ticket' && (selectedMultiTier || []).length > 0
              ? selectedMultiTier.find(multiTier => multiTier.active).sub_tiers.map(st => st.globaltix_ticket_id)
              : []
          )
        );
      },
      onDateChange: async (dateInput) => {
        const { sessionData } = props;
        const { status } = dateInput[0];
        const date = moment(dateInput[0].date).toISOString();
        await dispatch(sessionActions.setSessionData({ ...sessionData, date }, true));
        dispatch(availabilityActions.selectDate(date, { isInstant: status === 'available', isReplaceable: status === 'replaceable' }));
      }
    })
  )
);

class DatePicker extends Component {
  componentDidUpdate(prevProps) {
    const { isLoadingSessionData, sessionData, availability } = this.props;
    if (prevProps.isLoadingSessionData && !isLoadingSessionData) {
      const { selectedDate } = availability;
      const monthYear = moment(selectedDate.length > 0 ? selectedDate : sessionData.date).format('MMMM YYYY');
      this.props.onChangeMonthYearCallback(monthYear);
    }
  }

  render() {
    const { trip, availability, isLoadingSessionData, isSessionDataLoaded, sessionData } = this.props;
    if (trip.is_date_not_required) return null;
    const isTicket = trip.product_type === 'ticket';
    const showAvailable = showTodayOrTomorrowAvailable(trip);
    const isCalendarLoading = availability.isLoading && isSessionDataLoaded;
    const tripAvailabilities = availability.availabilities;
    const { selectedDate } = availability;
    return (
      <DatePickerContainer>
        {isTicket && showAvailable.length > 0 && (
          <AvailableTodayOrTomorrowContainer>
            <InstantIcon name="flash" />
            <Typo.Medium>Available {showAvailable.includes('today') ? 'Today' : 'Tomorrow'}</Typo.Medium>
          </AvailableTodayOrTomorrowContainer>
        )}
        {isLoadingSessionData && (
          <Form.DatePicker
            currentDate={createDateArray(moment().toISOString())}
            tripAvailabilities={[]}
          />
        )}
        {!isLoadingSessionData && (
          <Form.DatePicker
            currentDate={createDateArray(selectedDate.length > 0 ? selectedDate : sessionData.date)}
            loading={isCalendarLoading}
            onChange={this.props.onDateChange}
            onClose={(date) => this.props.onChangeMonthYearCallback(moment(date).format('MMMM YYYY'))}
            onChangeMonthYearCallback={this.props.onChangeMonthYearCallback}
            tripAvailabilities={tripAvailabilities}
          />
        )}
      </DatePickerContainer>
    );
  }
}

DatePicker.propTypes = {
  availability: PropTypes.object,
  isLoadingSessionData: PropTypes.bool,
  isSessionDataLoaded: PropTypes.bool,
  onChangeMonthYearCallback: PropTypes.func,
  onDateChange: PropTypes.func,
  sessionData: PropTypes.object,
  trip: PropTypes.object,
};

export default withTrip(enhance(DatePicker));
